import { Pipe, PipeTransform } from "@angular/core";

import { ReadableSizePipe } from "../bitspipe/bitspipe";

@Pipe({
  name: "service_speed",
})
export class ServiceSpeedPipe implements PipeTransform {
  private readableSizePipe = new ReadableSizePipe();
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return "";
    }
    return this.readableSizePipe.transform(value * 1000000);
  }
}
